import { InputTextField } from 'components/InputField'
import React from 'react'

import { useEffect, useRef, useState } from 'react'
import allImgPaths from 'assets/images';
import RfpDrag from './RfpDrag';

const RfpPhoto = ({ data: dataObj, handleDataChange }: any) => {
    const initValues = {
        file: null,
        filename: "Click to Upload",
        imageUrl: "",
        originalImageUrl: ""
    }

    const [formData, setFormData] = useState<any>(initValues);
    const [isNewImageUploaded, setIsNewImageUploaded] = useState(false)
    const actualBtnRef = useRef<any>(null);

    useEffect(() => {
        if (dataObj?.updatedTime) {
            if (dataObj?.content?.file) {
                const content = dataObj?.content
                setIsNewImageUploaded(false);
                const updatedContent = {
                    filename: content?.filename,
                    originalImageUrl: content?.originalImageUrl,
                    file: content.file,
                    imageUrl: content.imageUrl,
                    isNewImageUploaded: false,
                    previewUrl: content.previewUrl,
                    width: content?.width,
                    height: content?.height
                }
                setFormData(updatedContent);
            }
        }
    }, [dataObj?.updatedTime])


    const handleChange = (e: any) => {
        if (e.target.files.length > 0) {
            const tempUrl = URL.createObjectURL(e.target.files[0]);
            const fileName = e.target.files[0].name;
            const updatedContent = {
                filename: fileName, originalImageUrl: fileName, file: e.target.files[0], imageUrl: tempUrl, isNewImageUploaded: true, previewUrl: tempUrl
            }
            setFormData({ ...formData, ...updatedContent });
            setIsNewImageUploaded(true)

            // setItemData({ index, content: updatedContent, showLabel: isChecked })
            handleDataChange({ key: dataObj?.key, value: updatedContent })
        }
    };

    const removeFile = (e: any) => {
        const updatedContent = {
            filename: 'Click to Upload', originalImageUrl: '', file: null, imageUrl: '', previewUrl: ''
        }
        setFormData({ ...formData, ...updatedContent });
        handleDataChange({ key: dataObj?.key, value: updatedContent })
    };

    return (
        <>

            <div className="rounded-sm flex w-1/2">

                {/* Content */}
                <div className="w-full py-2 pr-2">
                    <div className="mb-2 flex justify-between items-center px-0.5">
                        <span className='font-interMedium text-sm text-[#344054]'>{dataObj.title || 'No Title'}</span>
                    </div>

                    <div className={`border border-[#D0D5DD] rounded-lg px-4 py-2 bg-[#fff] relative group hover:border-[#1e0af5] focus-within:border-[#1e0af5]`}>
                        <div className='flex items-center justify-between'>
                            {!formData?.imageUrl && (
                                <>
                                    <div className='flex'>
                                        <input
                                            type='file'
                                            id='email-upload-btn'
                                            ref={actualBtnRef}
                                            onChange={handleChange}
                                            hidden
                                            style={{ 'display': 'none' }}
                                            accept=".png,.jpg,.jpeg"
                                        />
                                        <div className="flex items-center gap-x-2 cursor-pointer text-[#D0D5DD]" onClick={() => actualBtnRef?.current?.click()}>
                                            <span>{formData.filename}</span>
                                        </div>
                                    </div>
                                </>
                            )}
                            {formData?.imageUrl && (
                                <>
                                    <div className="flex items-center gap-x-2">
                                        <img src={allImgPaths.rfpFileLogo} alt="" />
                                        <span className='truncate max-w-48'>{formData.filename}</span>
                                        <img className="cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1" src={allImgPaths.closeIcon} alt=""
                                            onClick={removeFile} />
                                    </div>
                                </>
                            )}

                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default RfpPhoto